import React, { useEffect, useState } from 'react';
import 'materialize-css/dist/css/materialize.min.css';
import 'materialize-css/dist/js/materialize.min.js';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import Select from 'react-select';
import axiosInstance from '../../axiosInstance';
import { useAuth } from '../../AuthContext';
import './modal.css';

const TeacherModal = ({ closeAddModal, data, open, mode, setIsOpen, teachers }) => {
  const { user } = useAuth();
  
  // ============================================
  // STATE MANAGEMENT
  // ============================================
  const [isDisable, setDisable] = useState(false);
  const [showLevelMarks, setShowLevelMarks] = useState(false);
  const [currentLevel, setCurrentLevel] = useState(data?.levelMarks?.level || '');
  
  // Change Center Feature
  const [showChangeCenterMode, setShowChangeCenterMode] = useState(false);
  const [allCenters, setAllCenters] = useState([]);
  const [selectedNewCenter, setSelectedNewCenter] = useState(null);
  const [changingCenter, setChangingCenter] = useState(false);
  
  // Certificate Feature
  const [selectedCertLevel, setSelectedCertLevel] = useState(null);
  const [distributingCert, setDistributingCert] = useState(false);

  // Prevents double-submit when user clicks Add/Save multiple times
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Teacher Centers (for Add mode)
  const [centersList, setCentersList] = useState([]);

  // Form Data
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    regId: null,
    pin: '',
    birthDate: null,
    mobileNo: '',
    level: '',
    centerId: '',
    certificate: null,
    standard: '',
    address: '',
    birtDate: null,
    marks: '',
    center: '',
    assignTeacher: '',
    type: '',
    email: '',
    levelMarks: {
      level: ''
    }
  });

  const typeOptions = [
    { value: 'F', label: 'Foundation' },
    { value: 'K', label: 'Kids' },
    { value: 'P', label: 'Primary' },
    { value: 'S', label: 'Secondary' }
  ];

  // ============================================
  // EFFECTS
  // ============================================
  
  useEffect(() => {
    if (mode === 'View' && data) {
      setFormData(data);
      console.log(data,"data")
    }
  }, [data, mode]);

  useEffect(()=>{
      setCurrentLevel(formData.level !== null && formData.level !== '' ? formData.level : (formData.type === 'F' ? 0 : formData.type ? 1 : ''));


  },[formData])

  useEffect(() => {
    if (mode === 'View' && user.role !== 'ADMIN') {
      setDisable(true);
    } else {
      setDisable(false);
    }
  }, [mode, user.role]);

  useEffect(() => {
    if (mode === 'View' && user.role === 'ADMIN' && open) {
      fetchAllCenters();
    }
  }, [mode, user.role, open]);

  // ============================================
  // API CALLS
  // ============================================
  
  const fetchAllCenters = () => {
    if (user.role === 'ADMIN') {
      axiosInstance.get('/api/student/getAllCentersForAdmin')
        .then((res) => {
          const centersWithLabel = res.data.map(center => ({
            ...center,
            label: `${center.centerName} (${center.teacherName})`,
            value: center.centerId
          }));
          setAllCenters(centersWithLabel);
        })
        .catch((err) => {
          console.error('Error fetching centers:', err);
          alert('Failed to load centers');
        });
    }
  };

  // ============================================
  // HANDLERS
  // ============================================
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));

    
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    // Guard against re-entry when submit is already in progress
    if (isSubmitting) return;

    // VALIDATION: Type is required
    if (!formData.type || formData.type.trim() === '') {
      alert('❌ Student Type is required! Please select F/K/P/S.');
      return;
    }

    const submitData = { ...formData };
    delete submitData.center;
    delete submitData.levelMarks;

    setIsSubmitting(true);

    axiosInstance.post(`/api/student/add/${user.id}`, submitData)
      .then((res) => {
        alert(res.data || (mode === 'Add' ? 'Student added successfully!' : 'Student updated successfully!'));
        setIsOpen(false);
        // window.location.reload();
      })
      .catch((e) => {
        console.error(e);
        alert('Error: ' + (e.response?.data || e.message));
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleChangeCenter = () => {
    if (!selectedNewCenter) {
      alert('Please select a new center');
      return;
    }

    if (selectedNewCenter.value === formData.center?.id) {
      alert('This is already the student\'s current center');
      return;
    }

    const confirmChange = window.confirm(
      `Move ${formData.name} from "${formData.center?.name}" to "${selectedNewCenter.centerName}"?`
    );

    if (!confirmChange) return;

    setChangingCenter(true);

    axiosInstance.post(`/api/student/changeCenter`, null, {
      params: {
        studentId: formData.id,
        newCenterId: selectedNewCenter.value
      }
    })
      .then((res) => {
        alert('Center changed successfully!');
        setShowChangeCenterMode(false);
        setSelectedNewCenter(null);
        setIsOpen(false);
        window.location.reload();
      })
      .catch((err) => {
        alert('Failed: ' + (err.response?.data || err.message));
      })
      .finally(() => {
        setChangingCenter(false);
      });
  };

  // ============================================
  // CERTIFICATE FEATURE
  // ============================================
  
  const handleDistributeCertificate = () => {
    if (!selectedCertLevel) {
      alert('Please select a certificate level');
      return;
    }

    const confirmDist = window.confirm(
      `Distribute Level ${selectedCertLevel} certificate to ${formData.name}?`
    );

    if (!confirmDist) return;

    setDistributingCert(true);

    axiosInstance.post('/api/student/updateCertificate', null, {
      params: {
        studentId: formData.id,
        certificateLevel: selectedCertLevel
      }
    })
      .then(async (res) => {
        // After successful distribution, automatically download the certificate
        await handleDownloadCertificate(selectedCertLevel);
        alert('Certificate distributed and downloaded successfully!');
        setIsOpen(false);
        window.location.reload();
      })
      .catch((err) => {
        alert('Failed: ' + (err.response?.data || err.message));
      })
      .finally(() => {
        setDistributingCert(false);
      });
  };

  /**
   * Download certificate PDF for a student
   * @param {number} level - Optional specific level to download
   */
  const handleDownloadCertificate = async (level = null) => {
    // Check if level has certificate template (only 1-9 supported)
    console.log(level, "levelData3");
    // if (level !== null )  {
    //   alert(`❌ Certificate template for Level ${level} is not available.\n\nOnly Levels 1-9 have certificates.`);
    //   return;
    // }

    try {
      const url = level !== null 
        ? `/api/student/certificate/${formData.id}?level=${level}`
        : `/api/student/certificate/${formData.id}`;
        
      const response = await axiosInstance.get(url, {
        responseType: 'blob',
      });

      // Create a blob from the PDF data
      const blob = new Blob([response.data], { type: 'application/pdf' });

      // Create a download link
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      const levelSuffix = level !== null ? `_Level${level}` : '';
      link.download = `Certificate_${formData.name.replace(/\s+/g, '_')}${levelSuffix}.pdf`;

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Error downloading certificate:', error);
      
      // Try to read the error response as text (since responseType is blob)
      let errorMessage = 'Failed to download certificate';
      if (error.response?.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          errorMessage = errorText || errorMessage;
        } catch (e) {
          errorMessage = error.message;
        }
      } else {
        errorMessage = error.response?.data || error.message;
      }
      
      alert('❌ ' + errorMessage);
    }
  };

  const getPendingCertificates = () => {
    if (!formData.levelMarks) return [];
    
    const currentCert = formData.certificate !== null && formData.certificate !== undefined 
      ? formData.certificate 
      : -1;
    
    const pending = [];
    
    // Check each level - only add if student has marks AND marks > 80
    const levels = [
      { level: 0, marks: formData.levelMarks.l_f },
      { level: 1, marks: formData.levelMarks.l_1 },
      { level: 2, marks: formData.levelMarks.l_2 },
      { level: 3, marks: formData.levelMarks.l_3 },
      { level: 4, marks: formData.levelMarks.l_4 },
      { level: 5, marks: formData.levelMarks.l_5 },
      { level: 6, marks: formData.levelMarks.l_6 },
      { level: 7, marks: formData.levelMarks.l_7 },
      { level: 8, marks: formData.levelMarks.l_8 },
      { level: 9, marks: formData.levelMarks.l_9 },
      { level: 10, marks: formData.levelMarks.l_10 }
    ];
    
    for (const { level, marks } of levels) {
      // Only show if: Has marks AND marks > 80 AND certificate not yet given
      if (marks && marks > 80 && level > currentCert) {
        pending.push(level);
      }
    }
    
    return pending;
  };

  const pendingCertificates = getPendingCertificates();

  // ============================================
  // MOBILE-OPTIMIZED LEVEL MARKS
  // ============================================
  
  const renderLevelMarks = () => {
    if (!formData.levelMarks) return null;

    const levels = [
      { name: 'F', key: 'l_f', level: 0, fullName: 'Foundation' },
      { name: 'L1', key: 'l_1', level: 1, fullName: 'Level 1' },
      { name: 'L2', key: 'l_2', level: 2, fullName: 'Level 2' },
      { name: 'L3', key: 'l_3', level: 3, fullName: 'Level 3' },
      { name: 'L4', key: 'l_4', level: 4, fullName: 'Level 4' },
      { name: 'L5', key: 'l_5', level: 5, fullName: 'Level 5' },
      { name: 'L6', key: 'l_6', level: 6, fullName: 'Level 6' },
      { name: 'L7', key: 'l_7', level: 7, fullName: 'Level 7' },
      { name: 'L8', key: 'l_8', level: 8, fullName: 'Level 8' },
      { name: 'L9', key: 'l_9', level: 9, fullName: 'Level 9' },
      { name: 'L10', key: 'l_10', level: 10, fullName: 'Level 10' }
    ];

    const currentCert = formData.certificate || -1;

    return (
      <div style={styles.levelMarksContainer}>
        <h6 style={styles.sectionTitle}>📊 Level Progress</h6>
        
        {/* Mobile: Stack view - easier to read on small screens */}
        <div style={styles.levelMarksList}>
          {levels.map(level => {
            const marks = formData.levelMarks[level.key];
            const hasCert = currentCert >= level.level;
            const hasPendingCert = level.level <= (formData.levelMarks.level - 1) && !hasCert;
          
            if (!marks && !hasCert && !hasPendingCert) return null;
            
            return (
              <div 
                key={level.key} 
                style={{
                  ...styles.levelMarkRow,
                  backgroundColor: hasCert ? '#e8f5e9' : hasPendingCert ? '#fff3e0' : '#f5f5f5',
                  borderLeft: hasCert ? '5px solid #4caf50' : hasPendingCert ? '5px solid #ff9800' : '5px solid #ccc'
                }}
              >
                <div style={styles.levelRowLeft}>
                  <div style={styles.levelIcon}>
                    {hasCert ? '✅' : hasPendingCert ? '⚠️' : '⬜'}
                  </div>
                  <div>
                    <div style={styles.levelRowName}>{level.fullName}</div>
                    <div style={styles.levelRowStatus}>
                      {hasCert && <span style={{ color: '#4caf50', fontSize: '11px' }}>Certificate Given</span>}
                      {hasPendingCert && <span style={{ color: '#ff9800', fontSize: '11px' }}>Certificate Pending</span>}
                      {!marks && <span style={{ color: '#999', fontSize: '11px' }}>Not Attempted</span>}
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={styles.levelRowMarks}>
                    {marks || '--'}
                  </div>
                  {/* Download icon - only show for levels with certificate (level > 0 and not Foundation/Tenth) */}
                  {hasCert &&  (
                    <button
                      type="button"
                      onClick={() => handleDownloadCertificate(level.level)}
                      title={`Download Level ${level.level} Certificate`}
                      style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: '24px',
                        padding: '5px',
                        borderRadius: '4px'
                      }}
                    >
                      📄
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // ============================================
  // MOBILE-OPTIMIZED CERTIFICATE SECTION
  // ============================================
  
  const renderCertificateSection = () => {
    if (!formData.levelMarks ) return null;

    return (
      <div style={styles.certificateSection}>
        <h6 style={styles.certTitle}>📜 Certificate Distribution</h6>

        {pendingCertificates.length > 0 ? (
          <>
            {/* Mobile-Friendly Button List */}
            <div style={styles.certButtonList}>
              <div style={styles.certLabel}>Select Level to Distribute:</div>
              {pendingCertificates.map(level => (
                <button
                  key={level}
                  type="button"
                  onClick={() => setSelectedCertLevel(level)}
                  style={{
                    ...styles.certLevelButton,
                    backgroundColor: selectedCertLevel === level ? '#2196F3' : '#fff',
                    color: selectedCertLevel === level ? '#fff' : '#333',
                    border: selectedCertLevel === level ? '2px solid #2196F3' : '2px solid #ddd'
                  }}
                >
                  Level {level}
                  {selectedCertLevel === level && ' ✓'}
                </button>
              ))}
            </div>

            {/* Distribute Button (also downloads automatically) */}
            <button
              type="button"
              className="btn"
              onClick={handleDistributeCertificate}
              disabled={!selectedCertLevel || distributingCert}
              style={styles.distributeButton}
            >              {distributingCert ? 'Distributing...' : `📜 Distribute & Download Level ${selectedCertLevel || '?'}`}
            </button>
          </>
        ) : (
          <div style={styles.certComplete}>
            ✅ All completed certificates distributed!
            <div style={{ fontSize: '12px', marginTop: '8px', fontWeight: 'normal' }}>
              📄 Use the download icons above to download any certificate
            </div>
          </div>
        )}
      </div>
    );
  };

  // ============================================
  // MAIN RENDER
  // ============================================
  
  return (
    <Modal 
      open={open} 
      onClose={closeAddModal} 
      center
      styles={{
        modal: {
          maxWidth: window.innerWidth < 768 ? '95vw' : '700px',
          width: '100%',
          margin: '10px',
          padding: 0
        }
      }}
    >
      <div style={styles.container}>
        <h5 style={styles.modalTitle}>
          {mode === 'Add' ? '➕ Add Student' : mode === 'View' ? '👁️ View Student' : '✏️ Edit Student'}
        </h5>
        
        <form onSubmit={handleSubmit}>
          
          {/* Basic Info */}
          <div className="row">
            <div className="input-field col s12">
              <input
                name="regId"
                type="number"
                value={formData.regId || ''}
                onChange={handleChange}
                disabled={true}
              />
              <label className="active">Reg ID</label>
            </div>
            
            <div className="input-field col s12">
              <input
                name="name"
                type="text"
                value={formData.name || ''}
                onChange={handleChange}
                // disabled={isDisable}
                required
              />
              <label className="active">Full Name</label>
            </div>
          </div>

          {/* Contact Info */}
          <div className="row">
            <div className="input-field col s12">
              <input
                name="email"
                type="email"
                value={formData.email || ''}
                onChange={handleChange}
                // disabled={isDisable}
              />
              <label className="active">Email</label>
            </div>

            <div className="input-field col s12">
              <input
                name="mobileNo"
                type="text"
                value={formData.mobileNo || ''}
                onChange={handleChange}
                // disabled={isDisable}
              />
              <label className="active">Mobile No</label>
            </div>
          </div>

          {/* Student Details */}
          <div className="row">
            <div className="input-field col s6">
              <input
                name="standard"
                type="text"
                value={formData.standard || ''}
                onChange={handleChange}
                // disabled={isDisable}
              />
              <label className="active">Standard</label>
            </div>

            <div className="input-field col s6">
              <Select
                name="type"
                options={typeOptions}
                onChange={(t) => {
                  const newLevel = t.value === 'F' ? 0 : 1;
                  setFormData((prev) => ({ ...prev, type: t.value, level: newLevel }));
                }}
                value={typeOptions.filter((t) => t.value === formData.type)}
                isDisabled={mode !== 'Add' || isDisable}
                styles={selectStyles}
                placeholder="Select Type *"
              />
              <label className="active">Type * {mode !== 'Add' && '(cannot be changed)'}</label>
            </div>
          </div>

          <div className="row">
            <div className="input-field col s12">
              <input
                name="birtDate"
                type="date"
                value={formData.birtDate || ''}
                onChange={handleChange}
                // disabled={isDisable}
              />
              <label className="active">Birth Date</label>
            </div>
          </div>

          {/* Level (Shows current level) & Marks (Editable) */}
          <div className="row">
            <div className="input-field col s6">
              <input
                name="level"
                type="number"
                value={currentLevel}
                disabled={true}
                style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
              />
              <label className="active">Level</label>
            </div>

            <div className="input-field col s6">
              <input
                name="marks"
                type="number"
                value={formData.marks || ''}
                onChange={handleChange}
                min="0"
                max="100"
              />
              <label className="active">Marks</label>
            </div>
          </div>

          {/* Address */}
          <div className="row">
            <div className="input-field col s12">
              <textarea
                name="address"
                className="materialize-textarea"
                value={formData.address || ''}
                onChange={handleChange}
                // disabled={isDisable}
                rows="2"
              />
              <label className="active">Address</label>
            </div>
          </div>

          {/* CENTER - Add Mode (Teacher) */}
          {mode === 'Add' && user.role !== 'ADMIN' && (
            <div className="row">
              <div className="input-field col s12">
                <Select
                  name="center"
                  onChange={(d) => {
                    setFormData((prev) => ({ ...prev, centerId: d.id }));
                  }}
                  value={user.centersList.filter((center) => center.id === formData.centerId)}
                  options={user.centersList}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  styles={selectStyles}
                />
                <label className="active">Select Center</label>
              </div>
            </div>
          )}

          {/* CENTER - Add Mode (Admin) */}
          {mode === 'Add' && user.role === 'ADMIN' && (
            <>
              <div className="row">
                <div className="input-field col s12">
                  <Select
                    name="assignTeacher"
                    onChange={(op) => {
                      setFormData((prev) => ({ ...prev, assignTeacher: op.id }));
                      axiosInstance.get(`/getAllCenters?teacherId=${op.id}`)
                        .then((res) => setCentersList(res.data))
                        .catch(console.error);
                    }}
                    options={teachers}
                    getOptionLabel={(option) => option.name}
                    getOptionValue={(option) => option.name}
                    styles={selectStyles}
                  />
                  <label className="active">Assign Teacher</label>
                </div>
              </div>

              {centersList.length > 0 && (
                <div className="row">
                  <div className="input-field col s12">
                    <Select
                      name="centerId"
                      onChange={(op) => {
                        setFormData((prev) => ({ ...prev, centerId: op.id }));
                      }}
                      options={centersList}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.value}
                      styles={selectStyles}
                    />
                    <label className="active">Assign Center</label>
                  </div>
                </div>
              )}
            </>
          )}

          {/* VIEW MODE - Current Center */}
          {mode === 'View' && formData.center && (
            <>
              <div className="row">
                <div className="input-field col s12">
                  <input
                    name="currentCenter"
                    type="text"
                    value={formData.center.name || ''}
                    disabled={true}
                  />
                  <label className="active">Current Center</label>
                </div>
              </div>

              {user.role === 'ADMIN' && !showChangeCenterMode && (
                <div className="row">
                  <button
                    type="button"
                    className="btn blue"
                    onClick={() => setShowChangeCenterMode(true)}
                    style={{ width: '100%', marginBottom: '10px' }}
                  >
                    Change Center
                  </button>
                </div>
              )}

              {user.role === 'ADMIN' && showChangeCenterMode && (
                <div style={styles.changeCenterBox}>
                  <div style={{ marginBottom: '10px' }}>
                    <strong>Change Center</strong>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      From: <strong>{formData.center?.name}</strong>
                    </div>
                  </div>

                  <div className="input-field">
                    <Select
                      placeholder="Select new center..."
                      onChange={(selected) => setSelectedNewCenter(selected)}
                      value={selectedNewCenter}
                      options={allCenters}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      isDisabled={changingCenter}
                      styles={selectStyles}
                    />
                    <label className="active">New Center</label>
                  </div>

                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button
                      type="button"
                      className="btn-flat"
                      onClick={() => {
                        setShowChangeCenterMode(false);
                        setSelectedNewCenter(null);
                      }}
                      disabled={changingCenter}
                      style={{ flex: 1 }}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn blue"
                      onClick={handleChangeCenter}
                      disabled={!selectedNewCenter || changingCenter}
                      style={{ flex: 1 }}
                    >
                      {changingCenter ? 'Changing...' : 'Confirm'}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}

          {/* LEVEL MARKS & CERTIFICATE */}
          {mode === 'View' && formData.levelMarks && (
            <div className="row">
              <div className="col s12">
                <button
                  type="button"
                  className="btn-flat"
                  onClick={() => setShowLevelMarks(!showLevelMarks)}
                  style={styles.toggleButton}
                >
                  {showLevelMarks ? '▼ Hide Level Marks & Certificates' : '▶ Show Level Marks & Certificates'}
                </button>

                {showLevelMarks && (
                  <div style={styles.levelMarksWrapper}>
                    {renderLevelMarks()}
                    {renderCertificateSection()}
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Submit Button */}
          <div className="row">
            <div className="col s12">
              <button 
                type="submit" 
                className="btn green"
                disabled={isSubmitting}
                style={{
                  ...styles.submitButton,
                  opacity: isSubmitting ? 0.6 : 1,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer'
                }}
              >
                {isSubmitting
                  ? (mode === 'Add' ? 'Adding...' : 'Saving...')
                  : (mode === 'Add' ? '➕ Add Student' : '💾 Save Changes')}
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

// ============================================
// MOBILE-OPTIMIZED STYLES
// ============================================

const styles = {
  container: {
    padding: '15px',
    maxHeight: '90vh',
    overflowY: 'auto'
  },
  modalTitle: {
    margin: '0 0 20px 0',
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1976d2',
    borderBottom: '2px solid #1976d2',
    paddingBottom: '10px'
  },
  sectionTitle: {
    margin: '0 0 15px 0',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333'
  },
  levelMarksContainer: {
    marginBottom: '20px'
  },
  levelMarksList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  levelMarkRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px',
    borderRadius: '8px',
    minHeight: '60px'
  },
  levelRowLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1
  },
  levelIcon: {
    fontSize: '24px',
    minWidth: '30px'
  },
  levelRowName: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#333'
  },
  levelRowStatus: {
    fontSize: '11px',
    marginTop: '2px'
  },
  levelRowMarks: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#333',
    minWidth: '50px',
    textAlign: 'right'
  },
  certificateSection: {
    marginTop: '20px',
    padding: '15px',
    backgroundColor: '#f0f8ff',
    borderRadius: '12px',
    border: '2px solid #2196F3'
  },
  certTitle: {
    margin: '0 0 15px 0',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#1976d2'
  },
  certSummary: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: '20px',
    padding: '15px',
    backgroundColor: '#fff',
    borderRadius: '8px'
  },
  certSummaryItem: {
    textAlign: 'center'
  },
  certSummaryLabel: {
    fontSize: '12px',
    color: '#666',
    marginBottom: '5px'
  },
  certSummaryValue: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#1976d2'
  },
  certButtonList: {
    marginBottom: '15px'
  },
  certLabel: {
    fontSize: '13px',
    fontWeight: 'bold',
    marginBottom: '10px',
    color: '#333'
  },
  certLevelButton: {
    width: '100%',
    padding: '0 15px',
    height: '50px',
    lineHeight: '50px',
    marginBottom: '8px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.2s',
    touchAction: 'manipulation',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  distributeButton: {
    width: '100%',
    padding: '0 15px',
    height: '50px',
    lineHeight: '50px',
    fontSize: '16px',
    fontWeight: 'bold',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  certComplete: {
    padding: '20px',
    backgroundColor: '#e8f5e9',
    borderRadius: '8px',
    color: '#2e7d32',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '14px'
  },
  changeCenterBox: {
    backgroundColor: '#f0f8ff',
    padding: '15px',
    borderRadius: '8px',
    border: '2px solid #2196F3',
    marginBottom: '15px'
  },
  toggleButton: {
    width: '100%',
    marginBottom: '15px',
    padding: '0 12px',
    height: '45px',
    lineHeight: '45px',
    fontSize: '14px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  levelMarksWrapper: {
    marginTop: '10px'
  },
  submitButton: {
    width: '100%',
    padding: '0 15px',
    height: '50px',
    lineHeight: '50px',
    fontSize: '16px',
    fontWeight: 'bold',
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

// React-Select mobile styles
const selectStyles = {
  control: (base) => ({
    ...base,
    minHeight: '48px',
    fontSize: '16px'
  }),
  option: (base) => ({
    ...base,
    padding: '12px',
    fontSize: '16px'
  })
};

export default TeacherModal;
